import { HStack } from "@/components/ui/hstack";
import { VStack } from "@/components/ui/vstack";
import { View } from "@/components/ui/view";
import { Text } from "@/components/ui/text";
import React, { useState } from 'react';
import { useSelector, useDispatch } from "react-redux";
import { requestModal } from '../../stores/mainSlice';

import i18n from 'i18n-js';
import Filter from "../components/basic/Filter";

import { ModalMaster } from '../components/modals/ModalWrapper/ModalMaster';
import ContactCardGroup from '../components/basic/ContactCardGroup';

export default function Contacts() {
  const dispatch = useDispatch();
  const [search, setSearch] = useState('');

  const user = useSelector((state) => state.user);

  const invite_users_from = useSelector((state) => state.contacts.requests) //
    .filter((_) => _.fromUser.id !== user.id)
    .map((state) => {
      return {
        id: state.id,
        createdAt: state.createdAt,
        contactAlias: state?.contactAlias,
        contactImage: state?.contactImage,
        fromUser: {
          id: state.fromUser.id,
          mail: state.fromUser.mail,
          preferredName: i18n.t('contactManagement.contactRequest'),
          userImage: { id: state.fromUser.id }
        },
        context: [
          {
            name: i18n.t('contactManagement.accept'),
            callback: () => {
              dispatch(requestModal({
                type: 'contact:accept-request',
                option: {
                  request: { id: state.id },
                  fromUser: { id: state.fromUser.id }
                }
              }));
            }
          },
          {
            name: i18n.t('contactManagement.deny'),
            action: 'negative',
            callback: () => {
              dispatch(requestModal({
                type: 'contact:decline-request',
                option: {
                  request: { id: state.id },
                  fromUser: { id: state.fromUser.id }
                }
              }));
            }
          },
        ]
      }
    });

  const invite_users_to = useSelector((state) => state.contacts.requests) //
    .filter((_) => _.toUser.id !== user.id)
    .map((state) => {
      return {
        id: state.id,
        contactAlias: state?.contactAlias,
        contactImage: state?.contactImage,
        toUser: {
          id: state.toUser.id,
          mail: state.toUser.mail,
          // preferredName: i18n.t('contactManagement.contactRequest'),
          userImage: { id: state.toUser.id }
        },
        context: [
          {
            name: i18n.t('contactManagement.cancel'),
            action: 'negative',
            callback: () => {
              dispatch(requestModal({
                type: 'contact:delete-request',
                option: {
                  request: { id: state.id },
                  toUser: { id: state.toUser.id }
                }
              }));
            }
          },
        ]
      }
    });

  const active_users = useSelector((state) => state.contacts.active).map((state) => {
    return {
      id: state.id,
      contactAlias: state?.contactAlias,
      contactImage: state?.contactImage,
      toUser: {
        id: state.toUser.id,
        mail: state.toUser.mail,
        preferredName: state.toUser.preferredName,
        userImage: { id: state.toUser.id }
      },
    }
  });

  const all_entries = [...active_users].map((state) => {
    return {
      contactAlias: state?.contactAlias,
      contactImage: state?.contactImage,
      user: {
        id: state.toUser.id,
        mail: state.toUser.mail,
        contactImage: state.contactImage,
        preferredName: state.toUser.preferredName,
        userImage: { id: state.toUser.id }
      },
      context: [
        {
          name: i18n.t('contact.update'),
          callback: () => {
            dispatch(requestModal({
              type: 'contact:update',
              option: { contact: { id: state.id }, toUser: { id: state.toUser.id } }
            }));
          }
        },
        {
          name: i18n.t('contact.deleteContact'),
          action: 'negative',
          callback: () => {
            dispatch(requestModal({
              type: 'contact:remove',
              option: { contact: { id: state.id }, toUser: { id: state.toUser.id } }
            }));
          }
        }
      ]
    }
  });

  // const filtered_entries = (!search ? all_entries : all_entries.filter((entry) => {
  //   return (
  //     // TODO(@Milo): add search logic
  //     entry.user.mail.includes(search) ||
  //     entry.user.preferredName.includes(search)
  //   );
  // })).sort((a, b) => {
  //   return a.user.preferredName > b.user.preferredName ? 1 : -1;
  // });


  const request = [
    {
      title: i18n.t('contactManagement.contactRequest'),
      nested: [
        {
          subtitle: i18n.t('contactManagement.requestFrom', { num: invite_users_from.length }),
          entries: invite_users_from,
          entries_max_rows: 1,
        },
        {
          subtitle: i18n.t('contactManagement.requestTo', { num: invite_users_to.length }),
          entries: invite_users_to,
          entries_max_rows: 1,
        }
      ].filter(_ => _.entries.length != 0)
    },
    {
      title: i18n.t('contact.contactsN', { num: (all_entries ?? []).length }),
      hasSearch: true,
      nested: [
        {
          entries: all_entries,
          entry_header: {
            // FIXME(@Milo): That action is missing an ARIA label
            icon: { name: 'group' },
            subicon: { name: 'add-circle' },
            callback: () => {
              dispatch(requestModal({
                type: 'contact:create',
                option: {}
              }));
            }
          }
        }
      ]
    },
  ].filter(_ => ('entry_header' in _ || _.nested.length != 0));

  return (
    <View className="flex-1" >
        <VStack className="flex-1 h-[100%] pt-9 px-10 pb-9 items-center overflow-y-scroll overflow-x-clip" >
          <VStack space='2xl' className="max-w-[100%] w-[1100px]">
            {request.map((parent, n) => {
              return (
                <VStack key={`${parent.title}--${n}`} space='xs'>
                    <Text className="ml-2 text-2xl font-[700] text-secondary-900">{parent.title}</Text>
                    {parent.hasSearch ? (
                      <VStack className="mt-5 mb-2">
                        <Filter search={search} setSearch={setSearch} />
                      </VStack>
                    ) : undefined}
                  {parent.nested ? parent.nested.map((nested, m) => {
                    return (
                      <ContactCardGroup
                        key={`${nested.subtitle}--${n}-${m}`}
                        subtitle={nested.subtitle}
                        search={search}
                        entries={nested.entries}
                        entriesMaxRows={nested.entries_max_rows}
                        entryHeader={nested.entry_header}
                        hasNarrowSidebar={true}
                      />
                    );
                  }) : undefined}
                </VStack>
              );
            })}
          </VStack>
        </VStack>

        <ModalMaster />
    </View>
  );
}
